import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
var FunctionInputOutput = /*#__PURE__*/function () {
  function FunctionInputOutput(obj) {
    this._name = obj.name;
    this._description = obj.description;
    this._type = obj.type;
  }

  _createClass(FunctionInputOutput, [{
    key: 'name',
    get: function get() {
      return this._name;
    },
    set: function set(val) {
      this._name = val;
    }
  }, {
    key: 'description',
    get: function get() {
      return this._description;
    },
    set: function set(val) {
      this._description = val;
    }
  }, {
    key: 'type',
    get: function get() {
      return this._type;
    },
    set: function set(val) {
      this._type = val;
    }
  }]);

  return FunctionInputOutput;
}();

export { FunctionInputOutput as default };